import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { retrieveDatetime } from "../../Services/PullingApiService";
import { useAuthHeader } from "../../auth/AuthService";

export function DateTimer({type}) {
    const {t, i18n} = useTranslation();
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [timeAmPm, setTimeAmPm] = useState("");
    const authHeader = useAuthHeader();
    var element = '';
    var DATE;
    
    async function updateDatetime() {
        await retrieveDatetime(authHeader())
        .then((response) => {
            let date = new Date(response.data.data.datetime)
            setDate((date.getDate() < 10 ? "0" : "") + date.getDate() + '-' + t(date.toLocaleString('default', { month: 'short' })) + '-' + date.getFullYear())
            DATE = date;
            timer()
        })
        .catch((error) => console.log(error))
    }
    
    function timer() {
        if(DATE) {
            setTime((DATE.getHours() < 10 || (DATE.getHours() > 12 && DATE.getHours() < 22)  ? "0" : "")+ DATE.toLocaleTimeString().replace("AM", '').replace("PM", ''));
            setTimeAmPm((DATE.getHours() < 10 || (DATE.getHours() > 12 && DATE.getHours() < 22)  ? "0" : "") + DATE.toLocaleTimeString().replace("AM",t("AM")).replace("PM",t("PM")));
            DATE = new Date(DATE.setSeconds(DATE.getSeconds() + 1));
        }
    }
    
    useEffect(() => {
        updateDatetime();
    
        if (type === 2 || type === 3) {
            var intervalTime = setInterval(timer, 1000);
        }
        const intervalDate = setInterval(updateDatetime, 600000);
        
        return () => {
            if (type === 2 || type === 3) {
                clearInterval(intervalTime);
            }
            clearInterval(intervalDate);
        }
    }, [i18n.language]);

    if (type === 1) {
        element = <>{date}</>
    } else if(type === 2) {
        element = <>{time}</>
    } else if(type === 3) {
        element = <>{timeAmPm}</>
    }
    return element;
}
